import http from "./httpService";

const apiEndpoint = "/services/app/Session";

export function getCurrentTenantInformation() {
  return http.get(apiEndpoint + "/GetCurrentTenantInformation");
}
